import React, { useState, useRef, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import TicketTypeForm from "./TicketTypeForm";

const EditTicketModal = ({ onEdit, ticketTypeSetting }) => {
  const [isPostable, setIsPostable] = useState(false);
  const dismissElement = useRef();
  const [ticketType, setTicketType] = useState({});
  const brand = useSelector((state) => state.brand);
  useEffect(() => {
    if (
      ticketType.layers &&
      !ticketType.layers.filter((item) => item.type === "").length &&
      !ticketType.layers
        .filter((item) => ["statement", "question"].includes(item.type))
        .find((item) => !item.value) &&
      !ticketType.layers
        .filter((item) => item.type === "assign_tokens")
        .find((item) => {
          if (item.value) {
            const { category, premierTokens, shoppingTokens } = item.value;
            if (category && (premierTokens || shoppingTokens)) return false;
            return true;
          }
          return true;
        })
    ) {
      setIsPostable(true);
    } else setIsPostable(false);
  }, [ticketType]);

  const handleClickClose = () => {
    dismissElement.current.click();
  };
  const handleChangeTicket = (ticketType) => {
    setTicketType(ticketType);
  };
  const handleClickUpdate = () => {
    onEdit(ticketType);
  };
  return (
    <div
      className="modal fade"
      id="edit_ticket_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Ticket Configuration</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <TicketTypeForm
              onChangeTicket={handleChangeTicket}
              initial={ticketTypeSetting}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              <Fragment>
                <button
                  type="button"
                  className="btn btn-orange"
                  data-dismiss="modal"
                >
                  Update Later
                </button>
                <button
                  type="button"
                  className="btn btn-green"
                  data-dismiss="modal"
                  disabled={!isPostable}
                  onClick={handleClickUpdate}
                >
                  Update
                </button>
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTicketModal;



// WEBPACK FOOTER //
// ./src/screens/Tasks/components/EditTicketModal.js